module.exports = __webpack_public_path__ + "static/media/map-marker-highlighted.d3c3d462.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-marker-highlighted.svg
// module id = 1411
// module chunks = 0